import React, { useState } from "react";
import { Box, Typography, Card, CardContent, Button, TextField } from "@mui/material";
import Navbar from "../Layouts/Navbar";
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import AperçuModal from "./ApercuModal";

export default function Rapports() {
  const [dates, setDates] = useState({});
   const [openap, setOpenAp] = useState(false);
    const handleOpenAp = () => setOpenAp(true);
    const handleCloseAp = () => setOpenAp(false);

  const handleDateChange = (key, field, value) => {
    setDates((prev) => ({
      ...prev,
      [key]: { ...prev[key], [field]: value },
    }));
  };

  const isApercuDisabled = (key) => {
    return !(dates[key]?.start && dates[key]?.end);
  };

  const cards = [
    { title: "BASE DE L’EFFECTIF" },
    { title: "BASE DES ADHÉRENTS" },
    { title: "HISTORIQUE DES INSCRITS", key: "historique_inscrits" },
    { title: "HISTORIQUE DES DÉSINSCRITS", key: "historique_desinscrits" },
    { title: "PLANNING JOURNALIER", key: "planning_journalier" },
    { title: "PLANNING JOURNALIER RÉEL", key: "planning_journalier_reel" },
    { title: "POINTAGE DES NAVETTES", key: "pointage_navettes" },
    { title: "POINTAGE DES NAVETTES ANNULÉES", key: "pointage_navettes_annulees" },
    { title: "TRANCHES HORAIRES ACTIVES" },
    { title: "ZONES ET POINTS D’ARRÊT ACTIVES" },
    { title: "PLANNING DES CIRCUITS JOURNALIER", key: "planning_circuits" }
  ];

  return (
    <>
      <Navbar />
      <Box p={3}>
        <Box display="flex" alignItems="center" mb={3}>
          <ContentPasteSearchIcon />
          <Typography variant="h5" ml={1}>
            RAPPORTS
          </Typography>
        </Box>
        <Box display="grid" gridTemplateColumns="repeat(4, 1fr)" gap={2}>
          {cards.map((card, index) => (
            <Card key={index} sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between", p: 2, textAlign: "center", boxShadow: 3 }}>
              <CardContent>
                <ContentPasteIcon fontSize="large" />
                <Typography mt={1} fontWeight="bold">{card.title}</Typography>
                {card.key && (
                  <Box display="flex" flexDirection="column" alignItems="flex-start" width="100%" mt={1}>
                    <Typography variant="body2" fontWeight="bold">Date début:</Typography>
                    <TextField
                      fullWidth
                      sx={{'& .MuiOutlinedInput-root': { height: 35, '&:hover fieldset': { borderColor: '#000' }, '&.Mui-focused fieldset': { borderColor: 'red' } }}}
                      margin="dense"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) => handleDateChange(card.key, "start", e.target.value)}
                    />
                    <Typography variant="body2" fontWeight="bold" mt={1}>Date fin:</Typography>
                    <TextField
                      fullWidth
                      sx={{'& .MuiOutlinedInput-root': { height: 35, '&:hover fieldset': { borderColor: '#000' }, '&.Mui-focused fieldset': { borderColor: 'red' } }}}
                      margin="dense"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) => handleDateChange(card.key, "end", e.target.value)}
                    />
                  </Box>
                )}
              </CardContent>
              <Box display="flex" justifyContent="space-between" p={2} gap={1}>
                <Button variant="contained" fullWidth sx={{ backgroundColor: '#000', color: '#fff', textTransform: 'none', '&:hover': { backgroundColor: 'red' } }}>Télécharger</Button>
                <Button
                  fullWidth
                  variant="contained"
                    onClick={handleOpenAp}
                  sx={{ backgroundColor: isApercuDisabled(card.key) ? "red" : "red", color: "white", textTransform: 'none', '&:hover': { backgroundColor: 'red' } }}
                  disabled={card.key && isApercuDisabled(card.key)}
                >
                  Aperçu
                </Button>
              </Box>
            </Card>
          ))}
        </Box>
        <AperçuModal open={openap} handleClose={handleCloseAp} />
      </Box>
    </>
  );
}
